import script from "./CreateAndEditCourseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAndEditCourseModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateAndEditCourseModal.vue?vue&type=style&index=0&id=022edc00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-022edc00"]])

export default __exports__